/**
 * @Author: v_jppjpeng
 * @Date: 2023-3-11 17:10:47
 * @Explain: 分层管理
 */

export default {
  // 列表
  'SEGMENTS.MANAGE.LIST.TITLE': '分层列表',
  'SEGMENTS.MANAGE.LIST.ADD': '创建分层规则',
  'SEGMENTS.MANAGE.LIST.PLEASE.ENTER.RULE.ID': '输入分层规则ID',
  'SEGMENTS.MANAGE.LIST.SEARCH.NAME.PLACEHOLDER': '输入分层规则名称',
  'SEGMENTS.MANAGE.LIST.DATA.EXCEPTION.TIPS': '数据异常，请检查',
  'SEGMENTS.MANAGE.LIST.RULE.NAME': '分层规则的名称',
  'SEGMENTS.MANAGE.LIST.COUNT.UPDATE.TIME': '订阅用户数量',
  'SEGMENTS.MANAGE.LIST.SUB.UPDATE.TIME': '订阅用户数量更新时间',
  'SEGMENTS.MANAGE.LIST.COUNT.UPDATE.TIME.TIPS': '在{time}更新的订阅者数量',
  'SEGMENTS.MANAGE.LIST.LAST.SAVED': '上次保存时间',
  'SEGMENTS.MANAGE.LIST.UPDATED.BY': '更新人',
  'SEGMENTS.MANAGE.LIST.EDIT.TITLE': '是否编辑此分层？',
  'SEGMENTS.MANAGE.LIST.EDIT.TIPS':
    '编辑分层规则会影响已经使用该规则的邮件任务。',
  'SEGMENTS.MANAGE.LIST.NOT.EDIT.TIPS':
    '该用户细分规则正在发送中，无法进行编辑',
  'SEGMENTS.MANAGE.LIST.DEL.TITLE': '确定删除分层规则？',
  'SEGMENTS.MANAGE.LIST.DEL.TIPS':
    '删除 <b class="color-333">{name}</b> 后，分层信息不可恢复。',
  'SEGMENTS.MANAGE.LIST.NOT.DEL.TIPS': '该用户细分正在发送中，无法进行编辑',
  'SEGMENTS.MANAGE.SEND.CAMPAIGN': '发送活动',
  'SEGMENTS.MANAGE.LIST.DESC.TIPS1':
    '分层规则支持组合复杂条件，当您仅需给单个标签发送活动，可在',
  'SEGMENTS.MANAGE.LIST.DESC.TIPS2': '标签列表',
  'SEGMENTS.MANAGE.LIST.DESC.TIPS3': '中快速创建活动',
  'SEGMENTS.LIST.HISTORY.VERSION.DISABLED':
    '系统交互界面已完成迭代更新，历史规则暂不支持编辑',

  // 创建 - 弹窗
  'SEGMENTS.MANAGE.LIST.CREATE.TITLE': '创建分层规则',
  'SEGMENTS.MANAGE.LIST.CREATE.SEGMENTS.NAME': '分层规则名称',
  'SEGMENTS.MANAGE.LIST.CREATE.ENTER.SEGMENTS.NAME': '输入名称',
  'SEGMENTS.MANAGE.LIST.CREATE.TIPS1':
    '可应用联系人字段和游戏内数据创建分层规则，',
  'SEGMENTS.MANAGE.LIST.CREATE.TIPS2':
    '每次查看或使用分层规则时，拉取最新用户信息。',

  // 内置分层
  'SEGMENTS.MANAGE.BUILT.IN': '预置分层',
  'SEGMENTS.MANAGE.LIST.BUILT.IN.TITLE': '分层规则',
  // 'SEGMENTS.MANAGE.LIST.BUILT.SUITABLE.SCENARIOS': '适用场景',
  // 'SEGMENTS.MANAGE.LIST.BUILT.CREATED.TEMPLATE': '作为模板新建',
  // 'SEGMENTS.MANAGE.LIST.BUILT.SEND.CAMPAIGN': '发送活动',
  'SEGMENTS.MANAGE.LIST.BUILT.VIEW.DETAILS': '查看详情',
  'SEGMENTS.MANAGE.LIST.BUILT.USE.TIPS':
    '分层功能只有在通过API同步游戏数据后才可用。如需详细信息，请查阅<a href="{ url }" target="_blank">如何创建细分用户</a>',

  // 新增，编辑，详情
  'SEGMENTS.MANAGE.ID': '分层 ID',
  'SEGMENTS.MANAGE.SEGMENTS.NAME': '分层规则名称',
  'SEGMENTS.MANAGE.PLEASE.ENTER.RULE.NAME': '请输入分层规则名称，上限50字符',
  'SEGMENTS.MANAGE.PLEASE.ENTER.RULE.NAME.CONFIRM': '请确认分层规则名称',
  'SEGMENTS.MANAGE.FILTER.CONDITIONS': '筛选条件',
  'SEGMENTS.MANAGE.FILTER.VALUE.DEL.TIPS': '部分选项已被删除，请重新选择',
  'SEGMENTS.MANAGE.RULE.CONDITIONS': '条件和规则',
  'SEGMENTS.MANAGE.CHECK.RULE.CONDITIONS': '请添加至少一个条件',
  'SEGMENTS.MANAGE.CONTACTS.MATCH': '符合以下',
  'SEGMENTS.MANAGE.ANY': '任一',
  'SEGMENTS.MANAGE.ALL': '全部',
  'SEGMENTS.MANAGE.OF.THE.FOLLOWING.CONDITIONS': '条件的联系人',
  'SEGMENTS.MANAGE.DATE.OPTIONS1': '在过去',
  'SEGMENTS.MANAGE.DATE.OPTIONS2': '在生命周期内',
  'SEGMENTS.MANAGE.DATE.OPTIONS3': '在一段时间内',
  'SEGMENTS.MANAGE.DATE.OPTIONS4': '近7天',
  'SEGMENTS.MANAGE.DATE.OPTIONS5': '近15天',
  'SEGMENTS.MANAGE.DATE.OPTIONS6': '近30天',
  'SEGMENTS.MANAGE.PLEASE.ENTER.NUMBER.DAYS': '请输入天数',
  'SEGMENTS.MANAGE.SOURCE.PLATFORM': '平台',
  'SEGMENTS.MANAGE.SOURCE.MANUAL': '手动上传',
  'SEGMENTS.MANAGE.SOURCE.API': 'API',
  'SEGMENTS.MANAGE.SOURCE.FORM': '表单',
  'SEGMENTS.MANAGE.SOURCE.PLAYTEST.HUB': '玩家测试中心',
  'SEGMENTS.MANAGE.SOURCE.JOIN.TIME': '加入时间',
  'SEGMENTS.MANAGE.SOURCE.JOIN.CHANNEL': '加入渠道',
  'SEGMENTS.MANAGE.SOURCE.FILTER': '筛选条件',
  'SEGMENTS.MANAGE.BEFORE': '早于',
  'SEGMENTS.MANAGE.AFTER': '晚于',
  'SEGMENTS.MANAGE.DAYS.UNTIL.NOW': '距离现在',
  'SEGMENTS.MANAGE.TIME.SLOT': '时间范围',
  'SEGMENTS.MANAGE.TIME.FROM': '从',
  'SEGMENTS.MANAGE.TIME.TO': '到',
  'SEGMENTS.MANAGE.SELECT.TIME': '请选择时间',
  'SEGMENTS.MANAGE.TIME.FROM.TO.LE': '时间范围选择有误，请检查',
  'SEGMENTS.MANAGE.TIME.ENTER.DAYS.UNTIL.NOW': '请输入距离现在',
  'SEGMENTS.MANAGE.TIME.DAYS.UNTIL.NOW.ERR': '距离现在输入有误，请检查',
  'SEGMENTS.MANAGE.ADD.MAX': '达到最大条件',
  'SEGMENTS.MANAGE.ADD.NEW.CONDITION': '添加新条件',
  'SEGMENTS.MANAGE.SEGMENTATION.DOCS': '细分文档',
  'SEGMENTS.MANAGE.CONDITION.TAG.TITLE': '您的联系人是如何被标记的',
  'SEGMENTS.MANAGE.CONDITION.FROM.TITLE': '您的联系人是如何获得的',
  'SEGMENTS.MANAGE.CONDITION.FIELD.TITLE': '有关您联系人的个人详细信息',
  'SEGMENTS.MANAGE.CONDITION.SEGMENT.TITLE': '您的联系人在游戏中做了什么',
  'SEGMENTS.MANAGE.CONDITION.USER.JOURNEY.TITLE': '邮件交互',
  'SEGMENTS.MANAGE.CONDITION.WHATSAPP.TITLE': 'WhatsApp活动参与',
  'SEGMENTS.MANAGE.CONDITION.SEGMENT.TIPS1':
    '此条规则通过API同步游戏数据后才可用。如需使用，请查阅<a href="{ url }" target="_blank">如何创建细分用户</a>。',
  'SEGMENTS.MANAGE.CREATE.DESC.TIPS1':
    '分层规则是通过将基本条件进行逻辑组合生成的。以下是使用所需的基本条件和前提条件的含义。如果您需要更多详细信息，请参考<a href="{ url }" target="_blank" class="font-weight-bold">如何创建细分用户</a>',
  'SEGMENTS.MANAGE.INT.EXTRA.NULL.LABEL': '同时选中空值联系人',

  // 关系
  'SEGMENTS.MANAGE.FILTER.OPERATOR.RANGE': '范围',
  'SEGMENTS.MANAGE.FILTER.OPERATOR.EQUAL.TO': '等于',
  'SEGMENTS.MANAGE.FILTER.OPERATOR.NOT.EQUAL.TO': '不等于',
  'SEGMENTS.MANAGE.FILTER.ENTER.INT': '请输入数字',
  'SEGMENTS.MANAGE.FILTER.MIN.LTE.MAX': '最小值≤最大值',
  'SEGMENTS.MANAGE.FILTER.MAX.GTE.MIN': '最大值≥最小值',
  'SEGMENTS.MANAGE.FILTER.DAYS.NOT.NULL': '天数不能为空',
  'SEGMENTS.MANAGE.FILTER.ENTER.NUMBER': '请输入数字',
  'SEGMENTS.MANAGE.FILTER.ENTER.DAYS.UNTIL.NOW': '请输入距离现在',

  // 标签 - 提示
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.INALL':
    '*系统内联系人的标签，具备选此处选择的全部标签',
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.INANY':
    '*系统内联系人的标签，具备任意一个此处选择的标签',
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.NOTINALL':
    '*系统内联系人的标签，不具备此处选择的全部标签',
  'SEGMENTS.MANAGE.OPERATOR.TAG.TIPS.NOTINANY':
    '*系统内联系人的标签，不具备任意一个此处选择的标签',

  // 来源 - 提示
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.INALL':
    '*系统内联系人的来源，具备选此处选择的全部来源',
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.INANY':
    '*系统内联系人的来源，具备任意一个此处选择的来源',
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.NOTINALL':
    '*系统内联系人的来源，不具备此处选择的全部来源',
  'SEGMENTS.MANAGE.OPERATOR.SOURCE.TIPS.NOTINANY':
    '*系统内联系人的标签，不具备任意一个此处选择的来源',

  // 偏好 - 提示
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.INALL':
  //   '*系统内联系人的偏好，具备选此处选择的全部偏好',
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.INANY':
  //   '*系统内联系人的偏好，具备任意一个此处选择的偏好',
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.NOTINALL':
  //   '*系统内联系人的偏好，不具备此处选择的全部偏好',
  // 'SEGMENTS.MANAGE.OPERATOR.PREFERENCE.TIPS.NOTINANY':
  //   '*系统内联系人的偏好，不具备任一一个此处选择的偏好',

  // 区域、语言 - 提示
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_COUNTRY.TIPS.IN':
    '*系统内联系人的字段值，具备任意一个此处选择的选项',
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_COUNTRY.TIPS.NOTIN':
    '*系统内联系人的字段值，不具备任意一个此处选择的选项',
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_LANGUAGE.TIPS.IN':
    '*系统内联系人的字段值，具备任意一个此处选择的选项',
  'SEGMENTS.MANAGE.OPERATOR.CUSTOM_FIELD_LANGUAGE.TIPS.NOTIN':
    '*系统内联系人的字段值，不具备任意一个此处选择的选项',

  // 自定义字段 - DropDown提示、偏好提示
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.INALL':
    '*系统内联系人的字段值，具备选此处选择的全部选项',
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.INANY':
    '*系统内联系人的字段值，具备任意一个此处选择的选项',
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.NOTINALL':
    '*系统内联系人的字段值，不具备此处选择的全部选项',
  'SEGMENTS.MANAGE.OPERATOR.DROPDOWN.TIPS.NOTINANY':
    '*系统内联系人的字段值，不具备任意一个此处选择的选项',

  // 自定义字段 - Text提示
  'SEGMENTS.MANAGE.OPERATOR.STRING.TIPS.=':
    '*系统内联系人的字段值，等于此处输入的内容',
  'SEGMENTS.MANAGE.OPERATOR.STRING.TIPS.!=':
    '*系统内联系人的字段值，不等于此处输入的内容',

  // 自定义字段 - Number提示
  'SEGMENTS.MANAGE.OPERATOR.INT.TIPS.RANGE':
    '*系统内联系人的字段值，处于此处输入的范围内',
  'SEGMENTS.MANAGE.OPERATOR.INT.TIPS.=':
    '*系统内联系人的字段值，等于此处输入的内容',
  'SEGMENTS.MANAGE.OPERATOR.INT.TIPS.!=':
    '*系统内联系人的字段值，不处于此处输入的范围内',

  // 联系人参与度
  'SEGMENTS.MANAGE.CONDITION.CONTACT.ENGAGEMENT.TITLE': '邮箱活动参与',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.TIME.RANGE': '时间范围',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.SELECT.TIME.RANGE': '选择时间范围',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.CAMPAIGNS': '活动',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.SELECT.CAMPAIGNS': '选择活动',
  'SEGMENTS.MANAGE.CONTACT.ENGAGEMENT.ENTER.CAMPAIGN.NAME': '输入活动名称',

  // 活动打开、点击条件
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.NONE': '选择的活动都没打开过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.AT.LAST.ONE': '选择的活动至少一个没打开过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICKED.NONE': '选择的活动都没点击过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICKED.AT.LAST.ONE':
    '选择的活动至少一个没点击过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SENT.NONE': '选择的活动都没发送过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SENT.AT.LAST.ONE': '选择的活动任意一个没发送过',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.NONE': '选择的活动全部都发送过',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.AT.LAST.ONE': '*选择的活动至少发送过一个',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICK.CAMPAIGNS': '*选择的活动均未点击过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.CLICK.RANGE': '*选择的时间范围的活动均未点击过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.CAMPAIGNS': '*选择的活动均未打开过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.OPEN.RANGE': '*选择的时间范围的活动均未打开过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SEND.CAMPAIGNS': '*选择的活动均未发送过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.SEND.RANGE': '*选择的时间范围的活动均未发送过',
  'SEGMENTS.MANAGE.ACTIVITY.NOT.READ': '*选择的时间范围的活动均未读过',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.RANGE': '*选择的时间范围的活动均发送过',
  'SEGMENTS.MANAGE.ACTIVITY.SENT.READ': '*选择的活动均发送过',

  // 已创建的分层规则的数据可能会被删除，删除后校验提示；
  'SEGMENTS.MANAGE.USER.EXTRA.CITATION.DELETED': '数据异常',
  'SEGMENTS.MANAGE.CITATION.DELETED': '已被删除',
  'SEGMENTS.MANAGE.CITATION.WAS.DELETED': '{deletedContentText} 被删除',

  // 用户旅程
  'SEGMENTS.MANAGE.USER.JOURNEY.CLICKED.LABEL':
    '包含在以下旅程节点中点击了邮件链接的玩家',
  'SEGMENTS.MANAGE.USER.JOURNEY.NOT.CLICKED.LABEL':
    '包含在以下旅程节点中未点击邮件链接的玩家',
  'SEGMENTS.MANAGE.USER.JOURNEY.OPENED.LABEL':
    '包含在以下旅程节点中打开了邮件的玩家',
  'SEGMENTS.MANAGE.USER.JOURNEY.NOT.OPENED.LABEL':
    '包含在以下旅程节点中未打开邮件的玩家',

  // 选择等级
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.CAMPAIGN': '活动',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.JOURNEY.POINT': '旅程节点',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.CAMPAIGN.LABEL': '选择活动的满意度评价',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.CAMPAIGN.PLACEHOLDER': '选择一个活动',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.RATING.LABEL': '选择满意度结果',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.JOURNEY.LABEL':
    '选择活动或当前旅程内自定义邮件节点的满意度评价',
  'SEGMENTS.MANAGE.RATING.ENGAGEMENT.JOURNEY.PLACEHOLDER':
    '选择一个活动或旅程节点',

  // 预览分层
  'SEGMENTS.PREVIEW': '提交',
  'SEGMENTS.PREVIEW.SAVE': '保存',
  'SEGMENTS.PREVIEW.IN.GAME.LEVEL': '等级',
  'SEGMENTS.PREVIEW.IN.GAME.TIMES': '次',
  'SEGMENTS.PREVIEW.TITLE.GROUP.DATE': '时间类型',
  'SEGMENTS.PREVIEW.TITLE.GROUP.STRING': '文本类型',
  'SEGMENTS.PREVIEW.TITLE.GROUP.DROPDOWN': '选项类型',
  'SEGMENTS.PREVIEW.TITLE.GROUP.INT': '数字类型',
  'SEGMENTS.PREVIEW.STATISTICS.TITLE': '包含已订阅联系人数量',
  'SEGMENTS.PREVIEW.STATISTICS.TIME': '统计时间：',
  'SEGMENTS.PREVIEW.STATISTICS.EMAIL.TITLE': '邮箱：已订阅 / 全部',
  'SEGMENTS.PREVIEW.STATISTICS.WHATSAPP.TITLE': 'WhatsApp：已订阅 / 全部',
  'SEGMENTS.PREVIEW.STATISTICS.TIME.2': '统计时间',
  'SEGMENTS.PREVIEW.COLON': '：',

  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS': '订阅状态',
  'SEGMENTS.MANAGE.SUBSCRIBE.CONTACTS': '人数',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.SUBSCRIBED': '已订阅',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.UNSUBSCRIBED': '未订阅',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.PENDING': '待定',
  'SEGMENTS.MANAGE.SUBSCRIBE.STATUS.UNKNOWN': '未知',
};
